import type { UploadFlow, UploadItem } from "../types";

const IMMEDIATE_STOP_UPLOAD_FLOWS: UploadFlow[] = [
  "home_library_import",
  "editor_object_import",
  "editor_library_attach",
];

/** attach-vse job은 file_conversion SSE·자동 VSE import 대상이 아님 */
export const skipsFileConversionJobMonitoring = (
  flow: UploadFlow | null | undefined,
): boolean => flow === "editor_library_attach";

type StopBehaviorTarget = Pick<UploadItem, "id" | "flow" | "kind">;
type StopBehaviorTargetInput = Pick<UploadItem, "flow" | "kind"> | null | undefined;

export const shouldImmediatelyStopUpload = (
  target: StopBehaviorTargetInput,
): boolean => {
  if (!target || target.kind === "download") {
    return false;
  }

  return (
    target.flow !== undefined &&
    IMMEDIATE_STOP_UPLOAD_FLOWS.includes(target.flow)
  );
};

export const partitionUploadStopTargets = <T extends StopBehaviorTarget>(
  targets: T[],
): {
  immediateStopTargets: T[];
  confirmStopTargets: T[];
} => {
  return targets.reduce(
    (result, target) => {
      if (shouldImmediatelyStopUpload(target)) {
        result.immediateStopTargets.push(target);
      } else {
        result.confirmStopTargets.push(target);
      }
      return result;
    },
    {
      immediateStopTargets: [] as T[],
      confirmStopTargets: [] as T[],
    },
  );
};
